"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.number.constructor");
var _dialog = _interopRequireDefault(require("@/mixins/dialog"));
var _doubleWeekPlan = require("@/http/interface/sfe/doubleWeekPlan");
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 时间冲突后，提示的冲突区间弹窗
 */
/** mixins */
/** services */
var _default2 = exports.default = {
  mixins: [_dialog.default],
  props: {
    // 所有下拉options配置
    /**
     * optConfig.planTypeOptions: [], // 计划任务select
     */
    optConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      form: {},
      initForm: {},
      loading: false,
      planTaskList: [] // 读取到的数据
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      // return `${this.formatDate(this.form.planTaskDate)} ${this.$t('doubleWeekPlan.title.existingMatters')}`
      return "".concat(this.$t('doubleWeekPlan.title.existingMatters'));
    }
  },
  // mounted() {
  //   this.init({
  //     planTaskDate: 20230706,
  //     actualPlanTaskFlag: 'Y',
  //     timeList: [
  //       {
  //         startTime: '00:00',
  //         endTime: '01:00'
  //       }
  //     ]
  //   })
  // },
  methods: {
    init: function init(params) {
      var _this = this;
      this.form = params;
      this.initForm = params;
      this.isShowModel = true;
      this.$nextTick(function () {
        _this.queryList();
      });
    },
    // 格式化日期 yyyyMMDD -> yyyy 年 MM 月 DD 日
    formatDate: function formatDate(date) {
      var str = String(Number(date));
      if (str && str.length === 8) {
        var arr = str.split('');
        arr.splice(8, 0, this.$t('common.day'));
        arr.splice(6, 0, this.$t('common.month'));
        arr.splice(4, 0, this.$t('common.year'));
        return arr.join('');
      } else {
        return '';
      }
    },
    // 格式化计划任务类型
    formatPlanType: function formatPlanType(key) {
      if (!key || !this.optConfig.planTypeOptions) {
        return '';
      }
      var txt = key || '';
      this.optConfig.planTypeOptions.some(function (item) {
        var bool = item.code === key;
        if (bool) {
          txt = item.name;
        }
        return bool;
      });
      return txt;
    },
    // 加载数据
    queryList: function queryList() {
      var _this2 = this;
      this.loading = true;
      (0, _doubleWeekPlan.getTimeList)(this.form).then(function (res) {
        var _ref = res || {},
          data = _ref.data;
        _this2.planTaskList = data || [];
      }).finally(function () {
        _this2.loading = false;
      });
    }
  }
};